var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 1037.09 406.35"}},[_c('title',[_vm._v("Sophie Kari")]),_c('text',{staticClass:"text",attrs:{"x":"50%","text-anchor":"middle","transform":"translate(0 379.59)"}},[_vm._v(" SOPHIE KARI ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }